import React from 'react';

/**
 * Footer component
 * contains link to github repo.
 */
export const Footer = () => {
  return (
    <footer className="footer">
      <p>&#169; 2020 Amith Raravi - source code on <a href="https://github.com/raravi/chat-app-client">Github</a></p>
    </footer>
  )
}
